var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Center, Text } from "@chakra-ui/react";
import { AiFillYoutube } from "react-icons/ai";
import { v4 } from "uuid";
export const AddPreview = (_a) => {
    var { onClick, widgetWidth } = _a, rest = __rest(_a, ["onClick", "widgetWidth"]);
    const data = {
        id: v4(),
        data: {
            videoUrl: "",
            displayTitle: false,
            displayQrCode: false,
            titleType: "default",
            customTitle: "Titre personnalisé",
            font: "Montserrat",
            size: 16,
            fontWeight: 400,
            textColor: "#FFFFFF",
            qrCodeSize: 16,
            qrCodeWeight: 400,
            qrCodeFont: "Montserrat",
            qrCodeTextColor: "#FFFFFF",
            qrCodeFgColor: "#FFFFFF",
            qrCodeBgColor: "#333333",
        },
    };
    return (React.createElement(Center, Object.assign({ onClick: () => onClick(data) }, rest, { gap: 2 }),
        React.createElement(AiFillYoutube, { size: (64 / 300) * widgetWidth, color: "red" }),
        React.createElement(Text, { fontFamily: "Rubik", fontWeight: "bold", fontSize: `${(36 / 300) * widgetWidth}px` }, "Youtube")));
};
